import { pushGaEvent } from "@kvix/shared";
import {
  Checkbox,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React, { useState } from "react";
import { useHistory } from "react-router";
import { LoadingOverlay } from "../../Session/partials/Overlays/Loading";

interface ButtonLargeProps {
  buttonText: String;
}

const useStyles = makeStyles((theme) => ({
  button: {
    "&.MuiButton-root": {
      background: "#fa255e",
      borderRadius: "26px",
      border: 0,
      color: "white",
      height: 52,
      padding: "0 30px",
      "&:hover": {
        backgroundColor: "#D62051",
      },
    },
    "&.label": {
      textTransform: "capitalize",
    },
  },
  dialog: {
    "&.scrollPaper": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    "&.scrollBody": {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&:after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "500px",
        width: "0",
      },
    },
    "&.paper": {
      margin: 32,
      background: "#f2f2f1",
      borderRadius: "12px",
      position: "relative",
      overflowY: "auto",
      "@media print": {
        overflowY: "visible",
        boxShadow: "none",
      },
    },
  },
  dialogContent: {
    "&.root": {
      flex: "1 1 auto",
      WebkitOverflowScrolling: "touch",
      overflowY: "auto",
      overflowX: "hidden",
      padding: "0px",
      "&:first-child": {
        paddingTop: 5,
      },
    },
  },
  bottomPadding: {
    paddingBottom: "8px",
  },
  dialogTitle: {
    marginBottom: "25px",
  },
  formController: {
    marginBottom: "25px",
  },
  bottomMargin: {
    marginBottom: "5px",
  },
  typographyBody1: {
    lineHeight: "24px",
  },
  divider: {
    margin: "10px 0",
  },
  formControlLabel: {
    textTransform: "uppercase",
    color: theme.palette.text.primary,
    "& .MuiFormControlLabel-label": {
      fontWeight: 700,
    },
  },
  select: {
    "& .MuiSelect-root": {
      padding: "27px 12px 10px",
    },
  },
}));

export const ButtonLarge: React.FC<ButtonLargeProps> = (props) => {
  const { buttonText } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openThankYouDialog, setOpenThankYouDialog] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();
    setLoading(true);

    const data = new URLSearchParams();
    for (const pair of new FormData(event.currentTarget)) {
      data.append(pair[0], pair[1] as string);
    }

    try {
      const response = await fetch(
        `https://kvix.us4.list-manage.com/subscribe/post-json?${data.toString()}`,
        {
          method: "GET",
          mode: "no-cors",
        }
      );

      pushGaEvent({
        category: "Become A Streamer Signup",
        action: "Streamer signed up",
      });
    } catch (e) {
      console.log(e);
    }

    setOpen(false);
    setLoading(false);
    setOpenThankYouDialog(true);
  };

  return (
    <>
      <LoadingOverlay visible={loading} view={"page"} />
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        onClick={() => setOpen(true)}
      >
        {buttonText}
      </Button>
      <Dialog
        className={classes.dialog}
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <form onSubmit={onSubmit}>
          <input type="hidden" name="u" value="756bfed9b452b52e2eab7e224" />
          <input type="hidden" name="id" value="b8802fd756" />
          <input type="hidden" name="v_id" value="47" />
          <input type="hidden" name="f_id" value="005851e3f0" />
          <input type="hidden" name="c" value="?" />
          <DialogContent className={classes.dialogContent}>
            <Typography variant="h4" className={classes.dialogTitle}>
              Tell us a bit about yourself and we will be in touch asap.
            </Typography>
            <FormControl fullWidth className={classes.formController}>
              <FormGroup className={classes.bottomPadding}>
                <TextField
                  label="Enter your email"
                  name="EMAIL"
                  required
                  type="email"
                  fullWidth
                  variant="filled"
                />
              </FormGroup>
              <FormGroup className={classes.bottomPadding}>
                <TextField
                  label="First name"
                  id="NAME"
                  name="NAME"
                  required
                  type="text"
                  fullWidth
                  variant="filled"
                />
              </FormGroup>
              <FormGroup className={classes.bottomPadding}>
                <TextField
                  label="Streamer name (if you have one)"
                  name="MMERGE3"
                  type="text"
                  fullWidth
                  variant="filled"
                />
              </FormGroup>
              <FormGroup className={classes.bottomPadding}>
                <TextField
                  label="Phone number"
                  name="MMERGE4"
                  type="tel"
                  fullWidth
                  variant="filled"
                  helperText="Remember to enter land code"
                />
              </FormGroup>
              <FormControl
                variant="filled"
                className={classNames([classes.bottomPadding, classes.select])}
              >
                <InputLabel id="MMERGE5-label">
                  Type of content you would be streaming
                </InputLabel>
                <Select
                  name="MMERGE5"
                  labelId="MMERGE5"
                  fullWidth
                  variant="filled"
                >
                  <option value="">None</option>
                  <option value="Yoga">Yoga</option>
                  <option value="Dance">Dance</option>
                  <option value="Mindfulness">Mindfulness</option>
                  <option value="Strength">Strength</option>
                  <option value="HIIT">HIIT</option>
                  <option value="Cardio">Cardio</option>
                  <option value="Meditation">Meditation</option>
                  <option value="Lectures">Lectures</option>
                  <option value="Lifestyle">Lifestyle</option>
                  <option value="Mobility">Mobility</option>
                  <option value="Functional training">
                    Functional training
                  </option>
                </Select>
              </FormControl>
              <FormGroup className={classes.bottomPadding}>
                <TextField
                  label="Not in the list above?"
                  name="MMERGE6"
                  type="text"
                  fullWidth
                  variant="filled"
                />
              </FormGroup>
            </FormControl>
            <Typography variant={"h5"} className={classes.bottomMargin}>
              Marketing Permissions
            </Typography>
            <Typography variant={"body1"} className={classes.typographyBody1}>
              Subscribe to the Kvix newsletter and stay up to date with all of
              the latest news and happenings in the world of wellness.
            </Typography>
            <FormControl component={"fieldset"}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox name="gdpr[44076]" value={"Y"} defaultChecked />
                  }
                  label="Subscribe"
                  className={classes.formControlLabel}
                ></FormControlLabel>
              </FormGroup>
            </FormControl>
            <Typography
              variant={"body1"}
              className={classNames([
                classes.bottomMargin,
                classes.typographyBody1,
              ])}
            >
              You can unsubscribe at any time by clicking the link in the footer
              of our emails. For information about our privacy practices, please
              visit our website.
            </Typography>
            <Divider className={classes.divider} />
            <Typography variant={"body2"}>
              We use Mailchimp as our marketing platform. By clicking below to
              subscribe, you acknowledge that your information will be
              transferred to Mailchimp for processing.{" "}
              <a href="https://mailchimp.com/legal/terms" target="_blank">
                Learn more about Mailchimp's privacy practices here.
              </a>
            </Typography>
            <div hidden={true}>
              <input type="hidden" name="tags" value="4449523" />
              <input
                type="text"
                name="b_756bfed9b452b52e2eab7e224_b8802fd756"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button variant={"contained"} type="submit" color={"primary"}>
              Sign up
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog
        open={openThankYouDialog}
        onClose={() => setOpenThankYouDialog(false)}
      >
        <DialogContent className={classes.dialogContent}>
          <Typography variant="h4" className={classes.dialogTitle}>
            Thank you!
          </Typography>
          <Typography variant="body1">
            We’re so glad you want to be a part of our team.
            <br /> You will hear from us soon.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => setOpenThankYouDialog(false)}
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
